var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { continueCameraRecord, finishCameraRecord, setUnhiddenContextMenuMode, startCameraRecord, stopCameraRecord } from "../../../../../../../../../../redux/actions/canvas/canvas";
import { useState } from "react";
export var CameraContext = function () {
    var _a = useSelector(function (state) { return state.canvas; }), instrument = _a.instrument, hiddenContextMenuMode = _a.hiddenContextMenuMode, isCameraActive = _a.isCameraActive, isCameraPaused = _a.isCameraPaused;
    var _b = __read(useState({
        mediaRecorder: null,
        stream: null,
        audio: null,
    }), 2), recordSetting = _b[0], setRecordSettings = _b[1];
    var recordScreen = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.mediaDevices.getDisplayMedia({ video: true })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_1 = _a.sent();
                    console.error("Failed to record screen:", err_1);
                    throw err_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var recordAudio = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                            audio: {
                                echoCancellation: true,
                                noiseSuppression: true,
                                sampleRate: 44100
                            }
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_2 = _a.sent();
                    console.error("Failed to record audio:", err_2);
                    throw err_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var saveFile = function (recordedChunks) {
        // Переписать на video/mp4
        var mimeType = 'video/webm';
        var blob = new Blob(recordedChunks, { type: mimeType });
        var downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = "".concat('screen-recording', ".webm");
        document.body.appendChild(downloadLink);
        downloadLink.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(downloadLink);
    };
    var setStreamMethods = function (mediaRecorder) {
        // The stream data is stored in this array
        var recordedChunks = [];
        mediaRecorder.onstop = function () {
            saveFile(recordedChunks);
            recordedChunks = [];
        };
        mediaRecorder.ondataavailable = function (e) {
            if (e.data.size > 0) {
                recordedChunks.push(e.data);
            }
        };
        // For every 200ms the stream data will be stored in a separate chunk.
        mediaRecorder.start(200);
    };
    var createRecorder = function (stream, audio) {
        var mixedStream = new MediaStream(__spreadArray(__spreadArray([], __read(stream.getTracks()), false), __read(audio.getTracks()), false));
        var mediaRecorder = new MediaRecorder(mixedStream);
        setStreamMethods(mediaRecorder);
        return mediaRecorder;
    };
    var startRecord = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stream, audio, mediaRecorder, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, recordScreen()];
                case 1:
                    stream = _a.sent();
                    return [4 /*yield*/, recordAudio()];
                case 2:
                    audio = _a.sent();
                    mediaRecorder = createRecorder(stream, audio);
                    startCameraRecord();
                    setRecordSettings({ mediaRecorder: mediaRecorder, stream: stream, audio: audio });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log('Start record error');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var finishRecord = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mediaRecorder, stream, audio;
        return __generator(this, function (_a) {
            finishCameraRecord();
            mediaRecorder = recordSetting.mediaRecorder, stream = recordSetting.stream, audio = recordSetting.audio;
            if (mediaRecorder) {
                mediaRecorder.stop();
                if (stream)
                    stream.getTracks().forEach(function (track) { return track.stop(); });
                if (audio)
                    audio.getTracks().forEach(function (track) { return track.stop(); });
            }
            setRecordSettings({ mediaRecorder: null, stream: null, audio: null });
            return [2 /*return*/];
        });
    }); };
    var stopRecord = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mediaRecorder;
        return __generator(this, function (_a) {
            stopCameraRecord();
            mediaRecorder = recordSetting.mediaRecorder;
            if (mediaRecorder && mediaRecorder.state === 'recording')
                mediaRecorder.pause();
            return [2 /*return*/];
        });
    }); };
    var continueRecord = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mediaRecorder;
        return __generator(this, function (_a) {
            continueCameraRecord();
            mediaRecorder = recordSetting.mediaRecorder;
            if (mediaRecorder && mediaRecorder.state === 'paused')
                mediaRecorder.resume();
            return [2 /*return*/];
        });
    }); };
    return (_jsxs("div", __assign({ className: clsx("context-canvas-menu", {
            'hidden': instrument !== 'camera' || !hiddenContextMenuMode
        }) }, { children: [_jsxs("div", __assign({ className: 'context-block' }, { children: [_jsxs("button", __assign({ onClick: startRecord, className: clsx("camera-btn start", { 'hidden': isCameraActive }) }, { children: [_jsx("i", { className: "pi pi-video" }), _jsx("span", { children: "Start record" })] })), _jsxs("button", __assign({ onClick: continueRecord, className: clsx("camera-btn start", {
                            'hidden': !isCameraActive || !isCameraPaused,
                        }) }, { children: [_jsx("i", { className: "pi pi-caret-right" }), _jsx("span", { children: "Continue record" })] })), _jsxs("div", __assign({ className: clsx({ 'hidden': !isCameraActive || isCameraPaused }, "buttons gap-1") }, { children: [_jsxs("button", __assign({ onClick: stopRecord, className: "camera-btn stop" }, { children: [_jsx("i", { className: "pi pi-pause" }), _jsx("span", { children: "Stop" })] })), _jsxs("button", __assign({ onClick: finishRecord, className: "camera-btn" }, { children: [_jsx("i", { className: "pi pi-stop-circle" }), _jsx("span", { children: "Finish" })] }))] }))] })), _jsxs("button", __assign({ onClick: function () { return setUnhiddenContextMenuMode(); }, className: "hide-context-button" }, { children: [_jsx("i", { className: "pi pi-chevron-left" }), _jsx("span", { children: "Hide settings" })] }))] })));
};
